import Icon from '../../../components/AppIcon';

const TechnicalDocumentationSection = () => {
  const handleDownloadPDF = () => {
    // Direct download link from Google Drive
    const link = document.createElement('a');
    link.href = 'https://drive.google.com/uc?export=download&id=1Hzj3gbaEMMTFzgREs5eCbRe-iQixlulX';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link?.click();
  };

  return (
    <section id="technical-docs" className="relative py-20 sm:py-32 bg-background overflow-hidden">
      <div className="relative max-w-content mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full text-primary text-sm font-medium mb-4">
              <Icon name="FileText" size={16} />
              <span>Техническая документация</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              Методическое пособие для инженеров
            </h2>
          </div>

          <div className="bg-card rounded-2xl p-8 sm:p-12 border border-border shadow-lg">
            <div className="flex flex-col items-center text-center">
              <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                <Icon name="BookOpen" size={40} color="var(--color-primary)" />
              </div>
              
              <h3 className="text-2xl font-bold text-foreground mb-6">
                «Любовь и 3я мировая»
              </h3>

              <div className="text-left space-y-4 text-secondary mb-8 max-w-2xl">
                <p>
                  Это методическое пособие для инженеров о том, на каких <strong>законах, теориях и математических моделях</strong> построен наш сервис.
                </p>
                <p>
                  Узнайте, почему AI Dating <strong>принципиально отличается</strong> от традиционных сервисов типа Tinder, Badoo и других платформ знакомств.
                </p>
                <p>
                  Мы не продаём доступ к анкетам. <strong>Мы продаём результат</strong> — тот уровень совместимости, который недостижим ни в Tinder, ни самостоятельно, ни с помощью свахи.
                </p>
                <p className="font-semibold text-foreground">
                  Это другой продукт. Вы покупаете результат тысячи виртуальных свиданий.
                </p>
              </div>

              <button
                onClick={handleDownloadPDF}
                className="inline-flex items-center gap-3 px-8 py-4 bg-primary text-primary-foreground rounded-lg font-semibold text-lg hover:bg-primary/90 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <Icon name="Download" size={24} />
                <span>Скачать методичку (PDF)</span>
              </button>

              <p className="text-sm text-secondary mt-4">
                Бесплатное методическое пособие для специалистов
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechnicalDocumentationSection;